export const getAffLink = (link: string, userId?: string, storeId?: string) => {
  const url = new URL("https://redirect.snaptheprice.com/go")
  url.searchParams.set("url", link)
  if (userId) {
    url.searchParams.set("userId", userId || "")
  }
  if (storeId) {
    url.searchParams.set("storeId", storeId || "")
  }
  return url.toString()
}
